module.exports = __webpack_public_path__ + "why2.webp?e168bc9f13b6442d2ad403da28b4ded4";